//@flow
import styled from "styled-components"

const DropPrompt = styled.div`
  background: ${({ theme }) => theme.accent};
  color: ${({ theme }) => theme.primaryText};
  padding: 0.875rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  font-weight: bold;
`

export default DropPrompt



// WEBPACK FOOTER //
// ./src/UI/FileUploader/DropPrompt.js